export function isDeprecatedFanhubEmbed(url: string) {
    return (
        url.indexOf('fanhubmedia') !== -1 ||
        url === 'http://www.thegame.com.au' ||
        url === 'http://www.thegame.com.au/'
    )
    // we redirect to https://thegame.com.au in prod now we control the site
    // so this should be safe
}
